import { injectTheme } from '@hub/design-system-base'
import { tabTheme } from './theme'

injectTheme('Tabs', tabTheme)

export { Tabs } from './tabs'
export { TabList } from './tab-list'
export { Tab } from './tab'
export { TabPanels } from './tab-panels'
export { TabPanel } from './tab-panel'
export type HubTabsVariants = keyof typeof tabTheme.variants
